import { Type } from '@angular/core';

export interface AlertModelBase {
  id?: string;
}

export type AlertType = 'error' | 'success';

export interface LoadingAlert extends AlertModelBase {
  closeBtn?: boolean;
  text: string;
  disappearTimeout?: number;
}

export interface ActionSuccessAlert extends AlertModelBase {
  actionText?: string;
  successText?: string;
  redirectAction?: () => any;
  disappearTimeout?: number;
}

export interface CustomAlert extends AlertModelBase {
  alertType: AlertType;
  closeBtn?: boolean;
  component: Type<unknown>;
  componentInput?: Record<string, unknown>;
  disappearTimeout?: number;
}

export interface UndoAlert extends AlertModelBase {
  alertType: AlertType;
  closeBtn?: boolean;
  undoAction: () => any;
  text: string;
  disappearTimeout?: number;
}

export interface TextAlert extends AlertModelBase {
  alertType: AlertType;
  closeBtn?: boolean;
  text: string;
  disappearTimeout?: number;
}

export interface ActionErrorAlert extends AlertModelBase {
  customBaseTranslationKey?: string;
  actionTranslationKey?: string;
  errorTranslationKey?: string;
  objectBodyTranslationKey?: string;
  errorBodyTranslationKey?: string;
  objectTranslationKey?: string;
  redirectAction?: () => any;
}

export interface TryAgainActionErrorAlert extends AlertModelBase {
  errorTranslationKey: string;
  tryAgainAction?: () => any;
  disappearTimeout?: number;
  tryAgainAdditionalTextKey?: string;
}

export type AlertKind = 'custom' | 'text' | 'component' | 'actionError' | 'tryAgainActionError' | 'undo' | 'loading' | 'actionSuccess';
export const AlertKindEnum = {
  custom: 'custom' as AlertKind,
  text: 'text' as AlertKind,
  component: 'component' as AlertKind,
  actionError: 'actionError' as AlertKind,
  actionSuccess: 'actionSuccess' as AlertKind,
  loading: 'loading' as AlertKind,
};

export interface AlertMetadata {
  id: string;
  alert: AlertModelBase;
  date: Date;
  alertKind: AlertKind;
}

export interface AlertsState {
  [alertId: string]: AlertMetadata;
}
